module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-spinner",
    class: {
      'no-z-index': this.display === 'inline', 'float-left': this.position === 'left', 'scale-down': this.size === 'small'
    },
    style: ({
      'color': this.color
    })
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71b48c86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/LoadingScreen.vue
// module id = 442
// module chunks = 1